export default String.raw`

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 200">
    <rect width="400" height="200" fill="white"/>
    <text x="200" y="100" font-size="36" font-weight="bold" fill="black" text-anchor="middle" dominant-baseline="middle">
        Cart-2 CPay
    </text>
</svg>
`;